import React from 'react'
import { connect } from 'react-redux'
import Button from '../../UI/Button'
import SignUpForm from './components'
import { 
  LoginSocialFacebook, 
  LoginSocialGoogle,
} from 'reactjs-social-login';

import Preloader from '../../UI/Preloader'
import Logo from '../../../assets/logo.svg'
import { GOOGLE_CLIENT_ID, FACEBOOK_APP_ID } from '../../../constants'

import * as actions from '../SignIn/actions'
import { GoogleButton } from '../GoogleButton';

class SignUp extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalIsOpen: false,
      loginGoogleLoading: null,
      loginFacebookLoading: null,
      loginAppleLoading: null
    }
  }

  responseFacebook = ({ data }) => {
    const { sendFacebookTokenId } = this.props
    sendFacebookTokenId(data.accessToken)
  }

  responseGoogleSuccess = (response) => {
    const { sendGoogleTokenId } = this.props
    sendGoogleTokenId(response.credential)
  }
  responseGoogleFailure = response => {}

  onAppleSignIn = async () => {
    const { sendAppleTokenId } = this.props
    sendAppleTokenId()
  }

  render() {
    const {
      loginGoogleLoading,
      loginFacebookLoading,
      loginAppleLoading
    } = this.state
    return (
      <main className="layout">
        <div className="auth">
          <div className="auth_placeholder">
            <img src={Logo} alt="logo" className="logo auth_logo" />
            <p className="auth_intro">Sign up</p>
            <div className="auth_social_buttons flex">
              <LoginSocialFacebook
                appId={FACEBOOK_APP_ID}
                fields="name,email"
                redirect_uri={process.env.REACT_APP_APP_URL + 'auth'}
                onResolve={this.responseFacebook}
                onReject={e => console.error(e)}
                isOnlyGetToken
              >
                <Button facebook>
                  Sign In with Facebook
                  {loginFacebookLoading && (
                    <Preloader
                      mini
                      style={{ position: 'absolute', right: '20px' }}
                    />
                  )}
                </Button>
              </LoginSocialFacebook>
              <GoogleButton onSuccess={this.responseGoogleSuccess} onError={this.responseGoogleFailure}>
                Sign In with Google
                {loginGoogleLoading && (
                  <Preloader
                    mini
                    style={{ position: 'absolute', right: '20px' }}
                  />
                )}
              </GoogleButton>
              <Button onClick={this.onAppleSignIn} apple>
                Sign In with Apple
                {loginAppleLoading && (
                  <Preloader
                    mini
                    style={{ position: 'absolute', right: '20px' }}
                  />
                )}
              </Button>
            </div>
            <span className="or">or</span>
            <SignUpForm />
          </div>
        </div>
      </main>
    )
  }
}

const mapStateToProps = state => ({})
const mapDispatchToProps = dispatch => ({
  sendGoogleTokenId: token => dispatch(actions.sendGoogleTokenId(token)),
  sendFacebookTokenId: token => dispatch(actions.sendFacebookTokenId(token)),
  sendAppleTokenId: () => dispatch(actions.sendAppleTokenId())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUp)
